import { client } from "./index";

// payload: { items: [{ productId, qty }], customer: { name, phone, address, city, pincode }, payment }
// Totals are never sent: the server prices the order.
// { order, customer, checkout, payError }: checkout opens Razorpay for a store paid through Razorpay
// { order, customer }: customer is the shopper with the delivery address saved to their profile
// token: a guest's sign-in from their email code, used for this order before it is saved on this browser
export const createOrder = (payload, token) =>
    client.post("/storefront/orders", payload, token ? { headers: { "x-auth-token": token } } : undefined).then((res) => res.data);
// Return or replace a delivered order: { type, reason, photos: [File] } sent as a form with the photos
export const requestReturn = (orderId, { type, reason, photos = [] }) => {
    const form = new FormData();
    form.append("type", type);
    form.append("reason", reason);
    photos.forEach((file) => form.append("photos", file));
    return client.post(`/storefront/orders/${encodeURIComponent(orderId)}/return`, form).then((res) => res.data);
};
// Checkout: what a coupon takes off this cart ({ coupon: { code, summary, description, discount } })
export const checkCoupon = (code, items) => client.post("/storefront/orders/coupon", { code, items }).then((res) => res.data);

// A gateway order: what Razorpay Checkout needs to take the payment. { order, checkout }: checkout is null if already paid.
export const payOrder = (orderId) => client.post(`/storefront/orders/${orderId}/pay`).then((res) => res.data);

// Razorpay Checkout's success result ({ paymentId, signature }); the server checks it with Razorpay. Resolves to the order.
export const confirmPayment = (orderId, result) =>
    client.post(`/storefront/orders/${orderId}/pay/confirm`, result).then((res) => res.data.order);

export const getOrders = (params = {}) => client.get("/storefront/orders", { params }).then((res) => res.data);

export const getOrderById = (orderId) => client.get(`/storefront/orders/${orderId}`).then((res) => res.data.order);
